import { ActionTypes } from './action-types.enum';

export const addCategories = (content, groupId) => ({
  type: ActionTypes.ADD_CATEGORIES,
  payload: {
    categories: content,
    groupId,
  }
});

export const addCategory = (content) => ({
  type: ActionTypes.ADD_CATEGORY,
  payload: {
    data: content,
  }
});

export const renameCategory = (content) => ({
  type: ActionTypes.RENAME_CATEGORY,
  payload: {
    data: content,
  }
});

export const deleteCategory = (id, groupId) => ({
  type: ActionTypes.DELETE_CATEGORY,
  payload: {
    id,
    groupId,
  }
});

export const setLastUsedCategory = (categoryId) => ({
  type: ActionTypes.SET_LAST_USED_CATEGORY,
  payload: {
    categoryId,
  }
});

export const updateCategoryCount = (type, count, groupId, previousCount = 0) => ({
  type: ActionTypes.UPDATE_CATEGORY_COUNT,
  payload: {
    type,
    count,
    groupId,
    previousCount,
  }
});
